import { usePartnerAccountsState } from './usePartnerAccountsState';

export function useSuperFanAccountsState({ adminFetch }) {
  return usePartnerAccountsState({
    adminFetch,
    endpoint: '/admin/superfan/accounts',
    role: 'super_fan',
    roleLabel: 'Super Fan',
  });
}
